import styled from 'styled-components';
import { accentColors } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  CommonBadgeStyles,
  CommonHeaderContentStyles,
  DarkBackgroundSummaryBadgeStyles,
  DarkModeMainAdjustmentStyles,
  MainContentBadgeStyles,
} from 'src/common/legacy-styles';
import { TextAndBackgroundColorStyles } from 'src/common/legacy-styles/text-and-bg-color';

import { ACCORDION_ANIMATION_DURATION } from './task-accordion.constants';

export const StyledGripIconContainer = styled.div`
  padding: 0.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme }) => theme.colors.grey[900]};
  position: absolute;
  top: 0.9rem;
  left: -1rem;
  display: none;
`;

export const StyledGripIcon = styled(FontAwesomeIcon)`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.grey[600]};
`;

export const StyledAccordionWrapper = styled.div<{ $isDark: boolean; isDragging: boolean; isOpen: boolean }>`
  margin-bottom: 1.6rem;
  svg {
    margin-left: 0 !important;
  }
  ${CommonHeaderContentStyles}

  .accordion-details-enter {
    max-height: 0;
    overflow: hidden;
  }
  .accordion-details-enter-active {
    max-height: 400rem;
    transition: max-height ${ACCORDION_ANIMATION_DURATION}ms ease;
  }
  .accordion-details-enter-done {
    max-height: fit-content;
  }
  .accordion-details-exit {
    max-height: 400rem;
    overflow: hidden;
    transition: max-height ${ACCORDION_ANIMATION_DURATION / 1.5}ms ease;
  }
  .accordion-details-exit-active {
    max-height: 0;
  }
  position: relative;
  &&:hover ${StyledGripIconContainer} {
    display: ${({ isOpen }) => (isOpen ? 'none' : 'block')};
  }

  opacity: ${({ isDragging }) => (isDragging ? '0' : '1')} !important;
`;

export const StyledAccordionSummary = styled.div<{ $isOpen: boolean }>`
  background-color: ${({ theme }) => theme.colors.secondary.light};
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  overflow: hidden;
  cursor: pointer;
  line-height: 2rem;
  padding: 1.4rem 1.8rem;
  gap: 1.2rem;
  border-radius: ${({ $isOpen }) => ($isOpen ? `0.5rem 0.5rem 0 0` : `0.5rem`)};

  ${CommonBadgeStyles}
  ${DarkBackgroundSummaryBadgeStyles}

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    align-items: flex-start;
  }
`;

export const StyledHeaderContentContainer = styled.div`
  background-color: inherit;
  display: flex;
  flex-grow: 1;
  align-items: center;
  gap: 1.2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    align-items: flex-start;
  }
`;

export const StyledTaskNumber = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${accentColors.info.dark};
  min-width: fit-content;
`;

export const StyledTaskTitle = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.grey[100]};
  max-width: 84rem;
  word-wrap: break-word;
`;

export const StyledChevronIcon = styled(FontAwesomeIcon)<{ $isOpen: boolean }>`
  color: ${({ theme }) => theme.colors.grey['100']};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  transform: rotate(${({ $isOpen }) => ($isOpen ? '-180deg' : '0deg')});
  transition: transform 0.3s ease;
`;

export const StyledTaskAccordionDetails = styled.div<{ $isDark: boolean }>`
  padding: 3rem;
  height: fit-content;
  overflow: hidden;
  position: relative;
  border-left-width: 0.5rem;
  border-left-style: solid;
  border-left-color: ${({ theme }) => theme.colors.info.main};

  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;

  ${TextAndBackgroundColorStyles}

  ${CommonBadgeStyles}
  ${MainContentBadgeStyles}
  ${DarkModeMainAdjustmentStyles}

  max-width: 1000px
`;
